import React, { useContext, useState } from "react";
import { ThreadContext } from "../context/ThreadContext";
import { FiMoreVertical, FiEdit2, FiTrash2, FiStar } from "react-icons/fi";
import { updateThreadTitle, deleteThread } from "../services/api";

export default function ThreadList({ onSelect }) {
  const { threads, updateThreadList } = useContext(ThreadContext);
  const [menuOpenId, setMenuOpenId] = useState(null);

  const handleSelect = (thread) => {
    onSelect(thread);
  };

  const handleRename = async (thread) => {
    const newTitle = prompt("Enter new chat name:", thread.title || "");
    if (newTitle && newTitle !== thread.title) {
      await updateThreadTitle(thread.thread_id, newTitle);
      updateThreadList();
    }
  };

  const handleDelete = async (thread) => {
    if (window.confirm("Are you sure you want to delete this chat?")) {
      await deleteThread(thread.thread_id);
      updateThreadList();
    }
  };

  const togglePin = async (thread) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:8000"}/threads/${thread.thread_id}/pin?is_pinned=${!thread.is_pinned}`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      updateThreadList();
    } catch (err) {
      console.error("❌ Error toggling pin:", err);
    }
  };

  if (!threads.length) {
    return <div className="text-gray-500 p-4">No previous chats</div>;
  }

  const sortedThreads = [...threads].sort((a, b) => {
    if (a.is_pinned && !b.is_pinned) return -1;
    if (!a.is_pinned && b.is_pinned) return 1;
    return new Date(b.created_at) - new Date(a.created_at);
  });

  return (
    <div className="p-4 border-r border-gray-200 h-full overflow-y-auto bg-gray-100">
      <h2 className="text-[#140D4F] font-semibold text-lg mb-4">Previous Chats</h2>
      <ul className="space-y-2">
        {sortedThreads.map((thread) => (
          <li
            key={thread.thread_id}
            className="group relative flex justify-between items-start px-3 py-2 rounded-md bg-white hover:bg-gray-100 text-[#140D4F] border border-gray-200"
          >
            <div className="flex items-start gap-2">
            <button
              onClick={() => togglePin(thread)}
              className={`mt-1 transition-colors ${
                thread.is_pinned ? "text-yellow-300" : "text-gray-500 hover:text-yellow-200"
              }`}
              title={thread.is_pinned ? "Unpin" : "Pin"}
            >
              <FiStar fill={thread.is_pinned ? "currentColor" : "none"} />
            </button>
              <span
                className="cursor-pointer w-40 break-words leading-snug text-sm"
                onClick={() => handleSelect(thread)}
              >
                {(thread.title && thread.title.length > 50)
                  ? thread.title.slice(0, 50) + "..."
                  : thread.title || "Untitled"}
              </span>
            </div>

            <div className="relative mt-1">
              <button
                onClick={() =>
                  setMenuOpenId(menuOpenId === thread.thread_id ? null : thread.thread_id)
                }
                className="ml-2 text-gray-400 hover:text-white"
              >
                <FiMoreVertical />
              </button>

              {menuOpenId === thread.thread_id && (
                <div className="absolute right-0 top-6 z-50 bg-white border border-gray-200 rounded-md shadow-md w-32">
                  <button
                    className="w-full flex items-center gap-2 px-3 py-2 hover:bg-gray-100 text-[#140D4F]"
                    onClick={() => {
                      handleRename(thread);
                      setMenuOpenId(null);
                    }}
                  >
                    <FiEdit2 />
                    Rename
                  </button>
                  <button
                    className="w-full flex items-center gap-2 px-3 py-2 hover:bg-red-50 text-red-600"
                    onClick={() => {
                      handleDelete(thread);
                      setMenuOpenId(null);
                    }}
                  >
                    <FiTrash2 />
                    Delete
                  </button>
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
